(() => {
  if (window.TachanCatalog) return;
  const requests = new Map();
  const jsonUrl = (raw, type) => {
    const url = new URL(raw, window.location.origin);
    if (url.origin !== window.location.origin) throw new Error('catalog_origin');
    const path = url.pathname.replace(/\/$/, '');
    const valid = type === 'product' ? /\/products\/[^/]+$/.test(path) : /\/cart$/.test(path);
    if (!valid) throw new Error('catalog_path');
    url.pathname = path + '.js';
    url.search = '';
    url.hash = '';
    return url.href;
  };
  const request = (url, force) => {
    if (force) requests.delete(url);
    if (!requests.has(url)) {
      const task = (async () => {
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), 8000);
        try {
          const response = await fetch(url, { method: 'GET', credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' }, signal: controller.signal });
          if (!response.ok) throw new Error('catalog_http_' + response.status);
          return await response.json();
        } finally { clearTimeout(timer); }
      })();
      requests.set(url, task);
      task.catch(() => { if (requests.get(url) === task) requests.delete(url); });
    }
    return requests.get(url);
  };
  const id = value => {
    const text = String(value);
    if (!/^[1-9]\d*$/.test(text)) throw new Error('catalog_id');
    if (typeof value === 'number' && !Number.isSafeInteger(value)) throw new Error('catalog_id');
    return text;
  };
  const image = value => {
    if (!value) return null;
    const raw = typeof value === 'string' ? value : value.src;
    if (typeof raw !== 'string') return null;
    const url = new URL(raw, window.location.origin);
    return url.protocol === 'https:' ? url.href : null;
  };
  const load = async ({ productId, productUrl, variantIds, currency, cartUrl, force = false }) => {
    const expectedId = id(productId);
    if (!Array.isArray(variantIds) || !variantIds.length || !/^[A-Z]{3}$/.test(currency)) throw new Error('catalog_config');
    const expected = variantIds.map(id);
    if (new Set(expected).size !== expected.length) throw new Error('catalog_variant_duplicate');
    const [product, cart] = await Promise.all([request(jsonUrl(productUrl, 'product'), force), request(jsonUrl(cartUrl, 'cart'), force)]);
    if (!product || id(product.id) !== expectedId || typeof product.available !== 'boolean' || !Array.isArray(product.variants)) throw new Error('catalog_product');
    if (!cart || cart.currency !== currency) throw new Error('catalog_currency');
    if (product.currency && product.currency !== currency) throw new Error('catalog_currency');
    const byId = new Map();
    for (const variant of product.variants) {
      const key = id(variant.id);
      if (byId.has(key)) throw new Error('catalog_variant_duplicate');
      if (variant.product_id && id(variant.product_id) !== expectedId) throw new Error('catalog_variant_product');
      byId.set(key, variant);
    }
    const variants = expected.map(key => {
      const variant = byId.get(key);
      if (!variant || typeof variant.available !== 'boolean' || typeof variant.price !== 'number' || !Number.isSafeInteger(variant.price) || variant.price < 0) throw new Error('catalog_variant');
      return Object.freeze({
        id: key,
        available: product.available === true && variant.available === true,
        price: variant.price,
        image: image(variant.featured_image) || image(variant.image) || image(product.featured_image),
        imageId: variant.featured_image?.id ? id(variant.featured_image.id) : null
      });
    });
    return Object.freeze({ productId: expectedId, currency, variants: Object.freeze(variants) });
  };
  window.TachanCatalog = Object.freeze({ load });
})();
